import React, { Component } from 'react'

import './Form.css'

class Form extends Component {

	onSubmit = (e) => {
		e.preventDefault()
		if (this.props.onSubmit) {
			this.props.onSubmit()
		}
	}

	render() {
		return (
			<form 
				className="Form"
				onSubmit={this.onSubmit}>
				{this.props.children}
			</form>
		)
	}
}

export default Form



// WEBPACK FOOTER //
// ./src/components/Form/Form.js